import slices from "./userSlice";
import { combineSlices } from "@reduxjs/toolkit";

const reducer = combineSlices({
  user: slices.reducer,
});

export default reducer;
